/**
 * Overview:
 * This component provides a reusable layout wrapper for dashboard widgets.
 * It standardizes widget presentation by handling titles, content rendering,
 * and responsive grid sizing, ensuring a consistent look and structure
 * across the dashboard.
 */
import React from "react";

interface WidgetLayoutProps {
  title?: string;
  children?: React.ReactNode;
  layout?: string; // e.g., "1" for single column, "2" for double column, "3" for triple column, etc.
}

const colSpanMap: Record<string, string> = {
  "1": "col-span-1",
  "2": "md:col-span-2",
  "3": "md:col-span-2 lg:col-span-3",
};

const WidgetLayout: React.FC<WidgetLayoutProps> = ({ title, children, layout = "1" }) => {
  return (
    <article
      className={`rounded-xl border border-gray-200 bg-white p-4 shadow-sm ${colSpanMap[layout]}`}
    >
      {title && (
        <header className="mb-3">
          <h2 className="text-base font-semibold">{title}</h2>
        </header>
      )}
      {children}
    </article>
  );
};

export default WidgetLayout;
